import {API_PATH} from "../../constants";
import {axiosRequest} from "../api";


export const PrescriptionParaclinicalServiceService = {
  getPrescriptionParaclinicalServiceItemsList(params: any){ return axiosRequest('GET', API_PATH.PARACLINICAL_SERVICE.LIST(params)) },
  getPrescriptionParaclinicalServiceItem(data: any){ return axiosRequest('POST', API_PATH.PARACLINICAL_SERVICE.INFO, data) },
  addPrescriptionParaclinicalServiceItem(data: any){ return axiosRequest('POST', API_PATH.PARACLINICAL_SERVICE.ADD, data) },
  deletePrescriptionParaclinicalServiceItem(data: any){ return axiosRequest('POST', API_PATH.PARACLINICAL_SERVICE.DELETE, data) },
}